import axios from "axios";

const getBundle = (locale) => axios.get(`/personal/api/v1/languages/${locale}`);

const getSupportedLanguages = () => axios.get(`/personal/api/v1/languages`);

export default {
    getBundle,
    getSupportedLanguages
}